export default __webpack_public_path__ + "static/media/img5.42c2221e.jpg";